import { render } from "./Solutions.vue?vue&type=template&id=0a32578e&scoped=true"
import script from "./Solutions.vue?vue&type=script&lang=js"
export * from "./Solutions.vue?vue&type=script&lang=js"

import "./Solutions.vue?vue&type=style&index=0&id=0a32578e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a32578e"]])

export default __exports__